import { useState } from 'react';

interface FreeGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function FreeGuideModal({ isOpen, onClose }: FreeGuideModalProps) {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const body = new URLSearchParams();
    data.forEach((value, key) => body.append(key, value.toString()));

    setLoading(true);
    try {
      await fetch('https://readdy.ai/api/form/d75e0qj41deorl02fahg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-[#0a1628] border border-[#f5a623]/30 rounded-2xl w-full max-w-md p-8 shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-white/40 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-xl" />
        </button>

        {!submitted ? (
          <>
            <div className="text-center mb-6">
              <div className="w-14 h-14 flex items-center justify-center bg-[#f5a623]/15 rounded-full border border-[#f5a623]/30 mx-auto mb-4">
                <i className="ri-download-2-fill text-[#f5a623] text-2xl" />
              </div>
              <h3 className="font-display text-2xl font-bold text-white uppercase mb-2">
                Get the Free Guide
              </h3>
              <p className="font-body text-sm text-white/55 leading-relaxed">
                Enter your email and we'll send the 7-step starter guide instantly.
              </p>
            </div>

            <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div>
                <label className="font-body text-xs text-white/50 uppercase tracking-wider mb-1 block">
                  Parent's Name
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="e.g. Jennifer Moore"
                  className="w-full bg-[#122040] border border-white/15 rounded-lg px-4 py-3 text-white font-body text-sm placeholder-white/25 focus:outline-none focus:border-[#f5a623]/60 transition-colors"
                />
              </div>
              <div>
                <label className="font-body text-xs text-white/50 uppercase tracking-wider mb-1 block">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="you@email.com"
                  className="w-full bg-[#122040] border border-white/15 rounded-lg px-4 py-3 text-white font-body text-sm placeholder-white/25 focus:outline-none focus:border-[#f5a623]/60 transition-colors"
                />
              </div>
              <div>
                <label className="font-body text-xs text-white/50 uppercase tracking-wider mb-1 block">
                  Athlete's Sport
                </label>
                <select
                  name="sport"
                  required
                  className="w-full bg-[#122040] border border-white/15 rounded-lg px-4 py-3 text-white font-body text-sm focus:outline-none focus:border-[#f5a623]/60 transition-colors cursor-pointer"
                >
                  <option value="">Select a sport...</option>
                  <option value="Football">Football</option>
                  <option value="Basketball">Basketball</option>
                  <option value="Soccer">Soccer</option>
                  <option value="Baseball">Baseball</option>
                  <option value="Softball">Softball</option>
                  <option value="Swimming">Swimming</option>
                  <option value="Track & Field">Track &amp; Field</option>
                  <option value="Volleyball">Volleyball</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#f5a623] text-[#0a1628] py-4 rounded-lg font-body font-extrabold text-base hover:bg-[#f7b84b] disabled:opacity-60 transition-all duration-200 whitespace-nowrap cursor-pointer mt-2"
              >
                {loading ? 'Sending...' : 'Send Me the Free Guide'}
              </button>
              <p className="text-center font-body text-xs text-white/30">
                No spam. Unsubscribe anytime.
              </p>
            </form>
          </>
        ) : (
          <div className="text-center py-6">
            <div className="w-16 h-16 flex items-center justify-center bg-emerald-500/15 rounded-full border border-emerald-500/30 mx-auto mb-5">
              <i className="ri-checkbox-circle-fill text-emerald-400 text-3xl" />
            </div>
            <h3 className="font-display text-2xl font-bold text-white uppercase mb-3">You're In!</h3>
            <p className="font-body text-sm text-white/60 leading-relaxed mb-6">
              Check your inbox — the free guide is on its way. Ready to go all in?
            </p>
            <a
              href="https://stan.store/The_RecruitingPlaybook/p/get-the-recruiting-playbook-now"
              target="_blank"
              rel="noopener noreferrer"
              onClick={onClose}
              className="inline-block bg-[#f5a623] text-[#0a1628] px-6 py-3 rounded-lg font-body font-bold text-sm hover:bg-[#f7b84b] transition-colors whitespace-nowrap cursor-pointer"
            >
              Get the Full Playbook — $47
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
